/* eslint-disable no-var */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var ButtonGroup = require("react-components/button-group.jsx");
var InfoTip = require("../components/info-tip.jsx");
var NumberInput = require("../components/number-input.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var RangeInput = require("../components/range-input.jsx");

var knumber = require("kmath").number;
var bound = function bound(x, gt, lt) {
    return Math.min(Math.max(x, gt), lt);
};

var EN_DASH = "\u2013";

var NumberLineEditor = React.createClass({
    displayName: "NumberLineEditor",

    propTypes: {
        range: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,

        labelRange: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
        labelStyle: React.PropTypes.string.isRequired,
        labelTicks: React.PropTypes.bool,

        divisionRange: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
        numDivisions: React.PropTypes.number.isRequired,
        snapDivisions: React.PropTypes.number,

        tickStep: React.PropTypes.number,
        correctRel: React.PropTypes.oneOf(["lt", "gt", "le", "ge", "eq"]),
        correctX: React.PropTypes.number,
        initialX: React.PropTypes.number,
        isTickCtrl: React.PropTypes.bool,

        onChange: React.PropTypes.func.isRequired,

        static: React.PropTypes.bool,
        showTooltips: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            range: [0, 10],

            labelRange: [null, null],
            labelStyle: "decimal",
            labelTicks: true,

            divisionRange: [1, 12],
            numDivisions: 5,
            snapDivisions: 2,

            tickStep: null,
            correctRel: "eq",
            correctX: null,
            initialX: null,

            showTooltips: false
        };
    },

    onRangeChange: function onRangeChange(range) {
        // Changing the range constrains the initial position, as well as the
        // position of the answer and labels. Atm, it just marks them as
        // invalid and prevents the number line from showing; it was annoying
        // to change it for them, because if they're typing in fractions,
        // it registers one-at-a-time and messes things up.
        this.props.onChange({ range: range });
    },

    onLabelRangeChange: function onLabelRangeChange(i, num) {
        var labelRange = this.props.labelRange.slice();
        var otherNum = labelRange[1 - i];

        if (num == null || otherNum == null) {
            labelRange[i] = num;
        } else {
            // If both labels have values, this updates the "appropriate" one.
            // It enforces that the position of the left label <= right label.
            // If left otherwise, it makes certain aspects of validation hard.
            labelRange = [Math.min(num, otherNum), Math.max(num, otherNum)];
        }

        this.props.onChange({ labelRange: labelRange });
    },

    onDivisionRangeChange: function onDivisionRangeChange(divisionRange) {
        var numDivisions = this.props.numDivisions;
        numDivisions = bound(numDivisions, divisionRange[0], divisionRange[1]);
        this.props.onChange({
            divisionRange: divisionRange,
            numDivisions: numDivisions
        });
    },

    onNumChange: function onNumChange(key, value) {
        var opts = {};
        opts[key] = value;
        this.props.onChange(opts);
    },

    onNumDivisionsChange: function onNumDivisionsChange(numDivisions) {
        var divRange = this.props.divisionRange.slice();

        if (!_.isFinite(numDivisions)) {
            numDivisions = null;
        }

        // Don't allow a fraction for the number of divisions
        numDivisions = Math.round(numDivisions);

        // Don't allow negative numbers for the number of divisions
        numDivisions = numDivisions < 0 ? numDivisions * -1 : numDivisions;

        // If the number of divisions isn't blank, update the number line
        if (numDivisions) {
            // Constrain numDivisions to be within the allowed range
            numDivisions = Math.min(divRange[1], Math.max(divRange[0], numDivisions));

            this.props.onChange({
                tickStep: null,
                divisionRange: divRange,
                numDivisions: numDivisions
            });
        }
    },

    onTickStepChange: function onTickStepChange(tickStep) {
        this.props.onChange({
            numDivisions: null,
            tickStep: tickStep
        });
    },

    onChangeRelation: function onChangeRelation(e) {
        var value = e.target.value;
        this.props.onChange({
            correctRel: value,
            isInequality: value !== "eq"
        });
    },

    onLabelStyleChange: function onLabelStyleChange(labelStyle) {
        this.props.onChange({
            labelStyle: labelStyle
        });
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    },


    render: function render() {
        var range = this.props.range;
        var labelRange = this.props.labelRange;
        var divisionRange = this.props.divisionRange;

        range[0] = +range[0];
        range[1] = +range[1];

        var width = range[1] - range[0];
        var numDivisions = this.props.numDivisions;
        var snapDivisions = this.props.snapDivisions;
        var tickStep = this.props.tickStep;
        var isTickCtrl = this.props.isTickCtrl;

        var step = void 0;
        if (!isTickCtrl) {
            // this will help constrain the answer to what is reachable
            step = tickStep ? tickStep / snapDivisions : width / numDivisions / snapDivisions;
        } else {
            // but if tickCtrl is on, the range of what is reachable is
            // rather large, and it becomes obnoxious to check for this
            step = null;
        }

        var labelStyleEditorButtons = [{
            value: "decimal",
            content: "0.75",
            title: "Decimals"
        }, {
            value: "improper",
            content: "\u2077\u2044\u2084",
            title: "Improper fractions"
        }, {
            value: "mixed",
            content: "1\xBE",
            title: "Mixed numbers"
        }, {
            value: "non-reduced",
            content: "\u2078\u2044\u2084",
            title: "Non-reduced"
        }];

        return React.createElement(
            "div",
            { className: "perseus-widget-number-line-editor" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Correct x",
                " ",
                React.createElement(
                    "select",
                    {
                        value: this.props.correctRel,
                        onChange: this.onChangeRelation
                    },
                    React.createElement(
                        "option",
                        { value: "eq" },
                        " = "
                    ),
                    React.createElement(
                        "option",
                        { value: "lt" },
                        " < "
                    ),
                    React.createElement(
                        "option",
                        { value: "gt" },
                        " > "
                    ),
                    React.createElement(
                        "option",
                        { value: "le" },
                        " \u2264 "
                    ),
                    React.createElement(
                        "option",
                        { value: "ge" },
                        " \u2265 "
                    )
                ),
                " ",
                React.createElement(NumberInput, {
                    value: this.props.correctX,
                    format: this.props.labelStyle,
                    onChange: this.onNumChange.bind(this, "correctX"),
                    checkValidity: function checkValidity(val) {
                        return val >= range[0] && val <= range[1] && (!step || knumber.isInteger((val - range[0]) / step));
                    },
                    placeholder: "answer",
                    size: "normal",
                    useArrowKeys: true
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "This is the correct answer. The answer is validated (as right or wrong) by using only the end position of the point and the relation (=, <, >, \u2264, \u2265)."
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                this.props.static ? React.createElement(
                    "label",
                    null,
                    "Range:"
                ) : React.createElement(
                    "label",
                    null,
                    "Position:",
                    " ",
                    React.createElement(NumberInput, {
                        value: this.props.initialX,
                        format: this.props.labelStyle,
                        onChange: this.onNumChange.bind(this, "initialX"),
                        placeholder: range[0],
                        checkValidity: function checkValidity(val) {
                            return val >= range[0] && val <= range[1];
                        },
                        useArrowKeys: true
                    }),
                    " \u2208 " /* element of (little E) symbol @Nolint */

                ),
                React.createElement(RangeInput, {
                    value: range,
                    onChange: this.onRangeChange,
                    format: this.props.labelStyle,
                    useArrowKeys: true
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "This controls the initial position of the point along the number line and the",
                        React.createElement(
                            "strong",
                            null,
                            "range"
                        ),
                        ", the position of the endpoints of the number line. Setting the range constrains the position of the answer and the labels."
                    ),
                    React.createElement(
                        "p",
                        null,
                        "In static mode, the initial position of the point is determined by Correct x instead of position."
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    "Labels:",
                    " ",
                    React.createElement(NumberInput, {
                        value: labelRange[0],
                        placeholder: range[0],
                        format: this.props.labelStyle,
                        checkValidity: function checkValidity(val) {
                            return val >= range[0] && val <= range[1];
                        },
                        onChange: this.onLabelRangeChange.bind(this, 0),
                        useArrowKeys: true
                    }),
                    React.createElement(
                        "span",
                        null,
                        " & "
                    ),
                    React.createElement(NumberInput, {
                        value: labelRange[1],
                        placeholder: range[1],
                        format: this.props.labelStyle,
                        checkValidity: function checkValidity(val) {
                            return val >= range[0] && val <= range[1];
                        },
                        onChange: this.onLabelRangeChange.bind(this, 1),
                        useArrowKeys: true
                    }),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "This controls the position of the left / right labels. By default, the labels are set by the range ",
                            React.createElement("br", null),
                            React.createElement(
                                "strong",
                                null,
                                "Note:"
                            ),
                            " Ensure that the labels line up with the tick marks, or it may be confusing for users."
                        )
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Style:",
                " ",
                React.createElement(ButtonGroup, {
                    allowEmpty: false,
                    value: this.props.labelStyle,
                    buttons: labelStyleEditorButtons,
                    onChange: this.onLabelStyleChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "This controls the styling of the labels for the two main labels as well as all the tick mark labels, if applicable. Your choices are decimal, improper fractions, mixed fractions, and non-reduced fractions."
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                !this.props.static && React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    React.createElement(PropCheckBox, {
                        label: "Show tick controller",
                        isTickCtrl: this.props.isTickCtrl,
                        onChange: this.props.onChange
                    })
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-right-col" },
                    React.createElement(PropCheckBox, {
                        label: "Show label ticks",
                        labelTicks: this.props.labelTicks,
                        onChange: this.props.onChange
                    })
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                !this.props.static && React.createElement(PropCheckBox, {
                    label: "Show tooltips",
                    showTooltips: this.props.showTooltips,
                    onChange: this.props.onChange
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                isTickCtrl && React.createElement(
                    "span",
                    null,
                    React.createElement(
                        "label",
                        null,
                        "Start num divisions at",
                        " ",
                        React.createElement(NumberInput, {
                            value: this.props.numDivisions || null,
                            format: "decimal",
                            onChange: this.onNumDivisionsChange,
                            checkValidity: function checkValidity(val) {
                                return val >= divisionRange[0] && val <= divisionRange[1];
                            },
                            placeholder: width / this.props.tickStep,
                            useArrowKeys: true
                        })
                    ),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "This controls the number (and position) of the tick marks. The number of divisions is constrained to",
                            " " + divisionRange[0] + EN_DASH + divisionRange[1],
                            ".",
                            React.createElement("br", null),
                            React.createElement(
                                "strong",
                                null,
                                "Note:"
                            ),
                            " The user will be able to specify the number of divisions in a number input."
                        )
                    )
                ),
                !isTickCtrl && React.createElement(
                    "span",
                    null,
                    React.createElement(
                        "label",
                        null,
                        "Num divisions:",
                        " ",
                        React.createElement(NumberInput, {
                            value: this.props.numDivisions || null,
                            format: "decimal",
                            onChange: this.onNumDivisionsChange,
                            checkValidity: function checkValidity(val) {
                                return val >= divisionRange[0] && val <= divisionRange[1];
                            },
                            placeholder: width / this.props.tickStep,
                            useArrowKeys: true
                        })
                    ),
                    " ",
                    React.createElement(
                        "label",
                        null,
                        "or tick step:",
                        " ",
                        React.createElement(NumberInput, {
                            value: this.props.tickStep || null,
                            format: this.props.labelStyle,
                            onChange: this.onTickStepChange,
                            checkValidity: function checkValidity(val) {
                                return val > 0 && val <= width;
                            },
                            placeholder: width / this.props.numDivisions,
                            useArrowKeys: true
                        })
                    ),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "This controls the number (and position) of the tick marks; you can either set the number of divisions (2 divisions would split the entire range in two halves), or the tick step (the distance between ticks) and the other value will be updated accordingly.",
                            " ",
                            React.createElement("br", null),
                            React.createElement(
                                "strong",
                                null,
                                "Note:"
                            ),
                            " There is no check to see if labels coordinate with the tick marks, which may be confusing for users if the blue labels and black ticks are off-step."
                        )
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Snap increments per tick:",
                    " ",
                    React.createElement(NumberInput, {
                        value: snapDivisions,
                        checkValidity: function checkValidity(val) {
                            return val > 0;
                        },
                        format: this.props.labelStyle,
                        onChange: this.onNumChange.bind(this, "snapDivisions"),
                        useArrowKeys: true
                    })
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "This determines the number of different places the point will snap between two adjacent tick marks.",
                        " ",
                        React.createElement("br", null),
                        React.createElement(
                            "strong",
                            null,
                            "Note:"
                        ),
                        "Ensure the required number of snap increments is provided to answer the question."
                    )
                )
            )
        );
    }
});

module.exports = NumberLineEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/number-line-editor.jsx
 ** module id = 131
 ** module chunks = 0 1
 **/